/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 * created by jpatel
 * tooltip show, hide and update functions
 *
 */

import React from 'react';
import ReactDOM from 'react-dom';
import {ToolTipModal} from '../../components/common/ToolTip';

export const wrapDynToolTip = function(Dyn) {

class ToolTip {

    constructor( paper, plotObj ) {
        this.element = null; //element;
        this.eventProp = null; //e;
        this.config = null; //options;
        this.plotObj = plotObj; // reference to container, to get view offset
        this.tipText = null;
        this.wrapperElement = document.createElement('div');
        this.wrapperElement.setAttribute('class', 'tde-tooltip-wrapper');
        document.body.appendChild(this.wrapperElement);
    }

	/**
	 * Show a tooltip over the given element (typically invoked on a hover-over event)
	 * @param element
	 * @param event
	 * @param options {*} -- optional x, y (position), alignRight (boolean), alignBottom (boolean).
	 */
    show( element, event, options) {
        "use strict";

		// save references
		this.element = element;
		this.eventProp = event;
		this.config = options;

        // Make sure only one tool tip can be displayed at a time.
		Dyn.assert( this.tipText === null );

        // Initialize the root element
        clearTimeout( this.unmountTimeout );
        if( ! this.toolTipWrapperEleRoot ) {
            this.toolTipWrapperEleRoot = ReactDOM.createRoot(this.wrapperElement);
        }
		// update the tooltip to the current position
		this.update( element, event, options );
    }

	/**
	 * update an already visible tooltip, to a new position or value.
	 * update() is like show(), but avoids flicker since tip is not hidden then immediately shown again.
	 * (typically invoked on a move event)
	 */
	update( element, event, options ) {
        const tipOffset  = { x:10, y:5 }; // tooltip offsets
        const paperOffset = this.plotObj.offset(); // element.paper.canvas.getBoundingClientRect().left, .right also works
		let tX, tY; // target x,y position

		// update references
        options = options || {};
		Dyn.assert( this.isMyElement(element )); // caller should use show() if fails
		this.eventProp = event;
		this.config = options;

		// get the x,y reference position, in viewport coordinates
		if( this.config && this.config.x && this.config.y ) {
            // caller has set x,y
            tX = this.config.x + paperOffset.left;
            tY = this.config.y + paperOffset.top;
        } else if( event.offsetX !== undefined && event.offsetY !== undefined ) {
            // offsetX, offsetX is usually available and correct mouse location in paper
            tX = event.offsetX + paperOffset.left;
            tY = event.offsetY + paperOffset.top;
        } else {
            // for non-mouse events, use the clickOrKeyboardEventToViewportXY() utility
		    let xy = Dyn.plotUtil.clickOrKeyboardEventToViewportXY( event, element );
		    tX = xy.x;
		    tY = xy.y;
        }
        // let debugXY = Dyn.plotUtil.clickOrKeyboardEventToViewportXY( event, element );
        // Dyn.debugging && console.log("tooltip.update", tX, tY,
        //     ["options.x:"+options.x, "event.offsetX:"+event.offsetX, "clickOrKeyboardEventToViewportXY.x:"+debugXY.x ],
        //     ["options.y:"+options.y, "event.offsetY:"+event.offsetY, "clickOrKeyboardEventToViewportXY.y:"+debugXY.y ] );

        // Align from right when not enough space on the right side
        if(!options.alignRight && (window.innerWidth - tX) < 100) {
            options.alignRight = true;
        }

        // offset the tooltip to avoid covering the element
        tY += (options.alignBottom) ? - tipOffset.y : tipOffset.y;
        tX += (options.alignRight) ? - tipOffset.x : tipOffset.x;
        Dyn.assertFiniteNumeric( tX, "undefined tooltip X position" );
        Dyn.assertFiniteNumeric( tY, "undefined tooltip Y position" );

        let position = 'rb'; // right bottom align
        if(options.alignRight) {
            position = "lb"; // left bottom align
            if(options.alignBottom) {
                position = "lt"; // left top align
            }
		} else if(options.alignBottom) {
            position = "rt"; // right top align
        }

        let transform;
        if(options.alignCenterY) {
            transform = 'cy';
        } else if(options.alignCenterX) {
            transform = 'cx';
        }

        this.toolTipWrapperEleRoot.render(
            React.createElement(ToolTipModal, {
                offset: {
                    x: tX,
                    y: tY,
                },
                position,
                transform,
                tip: Dyn.plotUtil.unescapeText( this.element.data( "tooltip" ) ),
                theme: Dyn.preferences.getTheme(),
            })
        );
	}

	/**
	 * hide a tooltip (typically invoked on a hover-out event)
	 */
    hide() {
        "use strict";

        // Unmount when DOM is available
        this._safeUnmount();

        this.tipText = null;

		this.element = null;
		this.eventProp = null;
		this.config = null;
    }

	/** return true if a tooltip is visible and pointing to the given Raphael element */
	isMyElement( anElement ) {
		return( anElement === this.element && this.element !== null && this.toolTipWrapperEleRoot );
	}

    _safeUnmount = () => {
        // remove the tooltip, with time delay to avoid "warning:
        //      Attempted to synchronously unmount a root while React was already rendering.
        //      React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        this.unmountTimeout = setTimeout(() => {
            this.toolTipWrapperEleRoot?.unmount();
            this.toolTipWrapperEleRoot = null;
        });
    }

} // class ToolTip
Dyn.ToolTip = ToolTip;
} // wrapDynToolTip
